export default __webpack_public_path__ + "static/broderie7.inspirations-3dcaea953f55debecfffc152b193a072.jpg";